// Utilities
import { retry } from "@ms/uno-utilities/lib/local/RetryUtilities";
import { lazy } from "react";
export const DeleteRecurringTaskDialogContainerLazyLoader = ()=>retry(()=>import(/* webpackChunkName: "planner-deleterecurringtaskdialogcontainer" */ "./DeleteRecurringTaskDialogContainer")).then((bundle)=>{
        return {
            default: bundle.DeleteRecurringTaskDialogContainer
        };
    });
export const LazyDeleteRecurringTaskDialogContainer = /*#__PURE__*/ lazy(DeleteRecurringTaskDialogContainerLazyLoader);
